var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCardHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#E9F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5629 25.6061L32.3116 17.3924V31.6802H11.4383V12.8942H13.5256V25.9818L19.2658 16.0252L26.0496 19.9703L30.4748 12.3202L32.2803 13.3639L26.8219 22.8091L20.0277 18.8953L13.8492 29.5929H16.2078L20.7895 21.7028L27.5629 25.6061Z",
    fill: "#1B4A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardHistory);
export default __webpack_public_path__ + "static/media/iconCardHistory.9b1f7fcd8724499630910337d743c0e3.svg";
export { ForwardRef as ReactComponent };